import React from "react";
import NewsletterArchives from "../newsletter-archives";
import Footer from "../global/footer";
import Header from "../global/header";

const NewsletterArchive = ({ headerv3, footer }) => {
  const { menuv3 } = footer;
  return (
    <>
      <Header header={headerv3} />
      <NewsletterArchives isBg="" />
      <Footer isBg="yes" menu={menuv3} />
    </>
  );
};

export default NewsletterArchive;
